import { render, staticRenderFns } from "./Liquidation.vue?vue&type=template&id=37c6fb52&scoped=true&"
import script from "./Liquidation.vue?vue&type=script&lang=js&"
export * from "./Liquidation.vue?vue&type=script&lang=js&"
import style0 from "./Liquidation.vue?vue&type=style&index=0&id=37c6fb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6fb52",
  null
  
)

export default component.exports